import axios from 'axios'
import { getEffectiveBackendUrl } from '../config/app'

const publicApi = axios.create({
  headers: { 'Content-Type': 'application/json' }
})

publicApi.interceptors.request.use((cfg) => {
  const base = getEffectiveBackendUrl()
  if (base) {
    cfg.baseURL = base
  }
  return cfg
})

export default publicApi
